/**
 * @package Ninja Forms
 * @subpackage Dashboard
 * @copyright (c) 2017 WP Ninjas
 * @since 3.2
 */
define( 'views/sections/apps.js',[], function() {
    var view = Marionette.View.extend( {
        template: '#tmpl-nf-apps'
    } );
    return view;
} );

